import React, { useState } from 'react';

export default function Help() {
    const [showContactInfo, setShowContactInfo] = useState(false);

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
            {/* Logo */}
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                <img
                    src="./media/logo/logo.png"
                    alt="Fundraising University"
                    style={{
                        height: '80px',
                        width: 'auto'
                    }}
                />
            </div>

            {/* Main Heading */}
            <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                <h1 style={{
                    fontSize: '3rem',
                    fontWeight: 'bold',
                    color: '#333',
                    marginBottom: '2rem',
                    textTransform: 'uppercase',
                    letterSpacing: '2px'
                }}>
                    How Can We Help?
                </h1>
            </div>

            {/* Customer Service Message */}
            <div style={{
                backgroundColor: '#f8f9fa',
                padding: '2rem',
                borderRadius: '10px',
                marginBottom: '3rem',
                textAlign: 'center'
            }}>
                <p style={{
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    color: '#333',
                    lineHeight: '1.6',
                    margin: 0,
                    textTransform: 'uppercase'
                }}>
                    Customer service is our top priority. If you reach out with any questions or concerns, we're committed to responding within 24 hours.
                </p>
            </div>

            {/* Common Questions Section */}
            <div>
                <h2 style={{
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    color: '#333',
                    marginBottom: '2rem',
                    textTransform: 'uppercase',
                    textDecoration: 'underline'
                }}>
                    Common Questions
                </h2>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                    {/* Question 1 - Clickable Link */}
                    <div>
                        <a
                            href="https://drive.google.com/file/d/1u_KE5BG-zYbeP73u9ssrXD5Q2RnYD1Bb/view?usp=drive_link"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                fontSize: '1.4rem',
                                fontWeight: 'bold',
                                color: '#0e456c',
                                textDecoration: 'none',
                                textTransform: 'uppercase',
                                cursor: 'pointer'
                            }}
                            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                        >
                            How do I register my discount card/ticket?
                        </a>
                    </div>

                    {/* Question 2 - Expandable */}
                    <div>
                        <h3 
                            onClick={() => setShowContactInfo(!showContactInfo)}
                            style={{
                                fontSize: '1.4rem',
                                fontWeight: 'bold',
                                color: '#0e456c',
                                margin: 0,
                                textTransform: 'uppercase',
                                cursor: 'pointer',
                                textDecoration: showContactInfo ? 'underline' : 'none'
                            }}
                            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseOut={(e) => e.target.style.textDecoration = showContactInfo ? 'underline' : 'none'}
                        >
                            Other help needed? {showContactInfo ? '▼' : '▶'}
                        </h3>
                        {showContactInfo && (
                            <div style={{
                                marginTop: '1rem',
                                padding: '1.5rem',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                borderLeft: '4px solid #0e456c'
                            }}>
                                <div style={{ marginBottom: '1rem' }}>
                                    <strong style={{ color: '#333', fontSize: '1.1rem' }}>Phone:</strong>
                                    <br />
                                    <a 
                                        href="tel:6025298293"
                                        style={{
                                            color: '#0e456c',
                                            textDecoration: 'none',
                                            fontSize: '1.1rem',
                                            fontWeight: '500'
                                        }}
                                    >
                                        (602) 529-8293
                                    </a>
                                </div>
                                <div>
                                    <strong style={{ color: '#333', fontSize: '1.1rem' }}>Email:</strong>
                                    <br />
                                    <a 
                                        href="mailto:support@fundraisingu.net"
                                        style={{
                                            color: '#0e456c',
                                            textDecoration: 'none',
                                            fontSize: '1.1rem',
                                            fontWeight: '500'
                                        }}
                                    >
                                        support@fundraisingu.net
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Question 3 - Clickable Link */}
                    <div>
                        <a
                            href="https://www.fundraisingu.net/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                fontSize: '1.4rem',
                                fontWeight: 'bold',
                                color: '#0e456c',
                                textDecoration: 'none',
                                textTransform: 'uppercase',
                                cursor: 'pointer'
                            }}
                            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                        >
                            Interested in fundraising or franchise opportunities?
                        </a>
                    </div>
                </div>
            </div>

            {/* Mobile Responsive Styles */}
            <style jsx>{`
                @media (max-width: 768px) {
                    h1 {
                        font-size: 2rem !important;
                    }
                }
            `}</style>
        </div>
    );
} 